



















import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class CompanyShowTabs extends Vue {
  get routeId(): string {
    return this.$route.params.id;
  }
}
